import { useContext, useEffect, useState } from 'react';
import { ImagesContext } from '../../contexts/ImagesContext';

interface Props {
  title: string
  type: string
  desc: string
  imgUrl: string
  handleBlockDelete: () => void
  handleBlockEdit: () => void
}
const Index = (props: Props) => {
  const {
    title, type, desc, imgUrl,
  } = props;
  const { handleBlockEdit, handleBlockDelete } = props;

  const { exchangeForUrl } = useContext(ImagesContext);
  const [blockImageUrl, setBlockImageUrl] = useState('/img/blocks/sample_block.png');

  useEffect(() => {
    if (imgUrl == null) {
      return;
    }

    if (imgUrl.trim().length === 0) {
      return;
    }

    exchangeForUrl(imgUrl).then((url) => {
      setBlockImageUrl(url);
    });
  }, [exchangeForUrl, imgUrl]);

  return (
    <div className="card">
      <div className="card-header d-flex position-relative">
        <div className="block-btn-top-left">
          <button type="button" className="block-circle-btn-edit" onClick={handleBlockEdit}>
            <i className="fa-solid fa-pen fa-fw" />
          </button>
        </div>
        <div className="block-header">
          <h5 className="block-title">{title}</h5>
          <p className="block-sub-title">{desc}</p>
        </div>
        <div className="block-btn-top-right hover-view">
          <button type="button" className="block-circle-btn-delete" data-bs-toggle="modal" data-bs-target="#blockdeleteModal" onClick={handleBlockDelete}>
            <i className="fa-regular fa-trash-can fa-fw" />
          </button>
        </div>
      </div>
      <div className="card-body d-flex">
        <div className="block-btn-bottom-left">
          {type === 'my-block' && (<div className="block-circle-myblock">マ</div>)}
        </div>
        <div className="block-image">
          <img src={blockImageUrl} alt="" />
        </div>
        <div className="block-btn-bottom-right" />
      </div>
    </div>
  );
};

export default Index;
